import { useContext, useState } from 'react';

import { Avatar, Button, Box, useTheme } from '@mui/material';

import { CloudUpload } from '@mui/icons-material';

import { AuthContext } from '../../context/Auth/AuthContext';

const AvatarUploader = ({ setAvatar, avatar, companyId }) => {
  const theme = useTheme();

  const [previewImage, setPreviewImage] = useState(null);
  const user = useContext(AuthContext);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setAvatar(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      {!previewImage && avatar ? (
        <>
          <Avatar
            src={`${import.meta.env.VITE_BACKEND_URL}/public/company${companyId}/user/${avatar}`}
            style={{ width: 120, height: 120 }}
          />
        </>
      ) : !avatar && !previewImage ? (
        <>
          <Avatar
            src={`${import.meta.env.VITE_BACKEND_URL}/public/app/noimage.png`}
            style={{ width: 120, height: 120 }}
          />
        </>
      ) : (
        <Avatar
          alt='Preview Avatar'
          src={previewImage ? previewImage : user.avatar}
          style={{ width: 120, height: 120 }}
        />
      )}

      <input
        accept='image/*'
        type='file'
        id='avatar-upload'
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <label htmlFor='avatar-upload' style={{ marginTop: 10 }}>
        <Button
          variant='outlined'
          component='span'
          sx={theme.custom.editButton}
          startIcon={<CloudUpload />}
        >
          Upload Avatar
        </Button>
      </label>
    </Box>
  );
};

export default AvatarUploader;
